import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useCmsAuth } from "../context/CmsAuthContext";

export default function CmsProtectedRoute({ requireOtp = true, module }) {
  const { user, loading, isCmsStaff, otpVerified, hasModule, mustSetPassword } =
    useCmsAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fafcfb] text-brand-dark">
        <p className="text-sm font-bold uppercase tracking-widest">Verificando acceso…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!isCmsStaff) {
    return <Navigate to="/admin/login" replace />;
  }

  if (requireOtp && !otpVerified) {
    return <Navigate to="/admin/otp" replace />;
  }

  if (
    requireOtp &&
    otpVerified &&
    mustSetPassword &&
    location.pathname !== "/admin/set-password"
  ) {
    return <Navigate to="/admin/set-password" replace />;
  }

  if (module && !hasModule(module)) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}
